// After bootShell returns: converge a workspace record that is still
// LIST-shaped to the full record.
//
// On a warm boot the first auth tick no longer upgrades the snapshot's list
// placeholder (functions/auth.js, `_warmPlaceholderHeld`) - bootShell's
// `boot-warm-reconcile` writes the composite boot's full record instead. When
// that reconcile resolved nothing (boot failed, no scope), the placeholder
// would stay list-shaped with nobody scheduled to complete it, so index.js
// calls this once bootShell has returned. On the common path the record is
// already full and this does nothing (no request); otherwise it hands the held
// record to the guarded setter, whose list->full upgrade goes through the
// shared getWorkspaceCached (one request at most, coalesced).
export const convergeBootWorkspace = (root, { sdk, getWorkspaceCached, setActiveWorkspaceRecord } = {}) => {
  const ws = root && root.workspace
  if (!ws || ws._shape === 'full' || ws._completionUnreachable) return false
  if (typeof setActiveWorkspaceRecord !== 'function') return false
  setActiveWorkspaceRecord(root, ws, { reason: 'boot-returned-converge', sdk, getWorkspaceCached })
  return true
}
